import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useEvent, useEventsOnViewLoad } from '@emerald-works/react-event-bus-client'
import { MobileContentGrid } from './mobile-content-grid'

const PAGE_SIZE = 10

const useStyles = makeStyles(({ spacing }) => ({
  wrapper: {
    padding: spacing(2)
  },
  title: {
    fontWeight: 700,
    marginBottom: spacing(1),
    color: '#FFFFFF'
  }
}))

let latestArticlesCache = { items: [] }

const MobileLatestArticlesCarousel = ({ onNavigate }) => {
  const classes = useStyles()
  const [items, setItems] = useState([])

  const [getNewestReleases] = useEvent([
    {
      eventName: 'contentSearchTenantContent',
      onSuccess: (payload) => {
        const content = payload.content || []
        setItems(content)
        latestArticlesCache = { items: content }
      }
    }
  ])

  useEventsOnViewLoad(() => {
    if (latestArticlesCache.items.length > 0) {
      setItems(latestArticlesCache.items)
      return
    }

    if (!getNewestReleases.hasBeenTriggered) {
      getNewestReleases.trigger({
        filters: {
          sort: 'createdAt:desc'
        },
        size: PAGE_SIZE,
        from: 0
      })
    }
  }, [getNewestReleases])

  return (
    <Box className={classes.wrapper}>
      <Typography variant='h6' fontWeight={700} fontSize={22} className={classes.title}>Latest Articles</Typography>
      <MobileContentGrid items={items} loading={getNewestReleases.isWorking} onNavigate={onNavigate} />
    </Box>
  )
}

export default MobileLatestArticlesCarousel
